import React, { Component } from "react";
import { ButtonToolbar, Table, Grid, Row, Col, FormGroup, ControlLabel } from 'react-bootstrap';
import Select from "react-select";

import { SearchHelper } from '../../helpers/SearchHelper';
import { ComparisonHelper } from '../../helpers/ComparisonHelper';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { PaginationBuilder } from '../../PaginationBuilder';
import { TableButton } from '../../TableButton';
import { LoadingSpinner } from '../../LoadingSpinner';
import { SortIndicator } from '../../SortIndicator';

export class PathsActive extends Component {
    constructor(props) {
        super(props);

        this.state = {
            render: {
                sort: {
                    property: "code",
                    type: "ascending"
                }
            }
        }
    }

    // -----------------------

    onChangeSort(property) {
        const { render } = this.state;

        render.sort.type = render.sort.property === property && "ascending" === render.sort.type ? "descending" : "ascending";
        render.sort.property = property;

        this.setState({
            render: render
        });
    }

    // ------------------

    sortPaths(sort, a, b) {
        let aValue = a[sort.property];
        let bValue = b[sort.property];

        if ("object" === typeof aValue) {
            aValue = undefined !== aValue.left ? aValue.left : aValue.right;
        }

        if ("object" === typeof bValue) {
            bValue = undefined !== bValue.left ? bValue.left : bValue.right;
        }

        if (undefined === aValue) {
            aValue = "";
        }

        if (undefined === bValue) {
            bValue = "";
        }

        if (aValue === bValue) {
            return 0;
        }

        const output = aValue < bValue ? -1 : 1;

        if ("descending" === sort.type) {
            return output * -1;
        }

        return output;
    }

    // ----------------------

    renderSortIndicator(property, sort) {
        if (property !== sort.property) {
            return (
                <SortIndicator order="none" />
            );
        }

        return (
            <SortIndicator order={sort.type} />
        );
    }

    renderIsTouristLabel(isTourist) {
        return isTourist ? "Sim" : "Não";
    }

    renderOrientationLabel(orientation) {
        if (undefined === orientation) {
            return undefined;
        }

        return orientation === "C" ? "Circular" : orientation === "R" ? "Volta" : "Ida"
    }

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderTable(lineSelected) {
        if (null === lineSelected || undefined === lineSelected) {
            return null;
        }

        const { paths, isLoadingPaths, isComparing, currentPage, elementsPerPage, filter } = this.props;
        const { render } = this.state;

        let pathsFiltered;
        if (isComparing) {
            const { draftPaths } = this.props;

            pathsFiltered = SearchHelper.search({
                filter: filter,
                data: ComparisonHelper.compare(
                    paths,
                    undefined === lineSelected ? [] : draftPaths.filter(dp => dp.lineCode === lineSelected.code),
                    {
                        match: [{ left: "code", right: "code" }],
                        fields: [{ left: "extCode", right: "externalCode" }, { left: "isTourist", right: "isTourist" }, { left: "orientation", right: "orientation" }, { left: "priority", right: "priority" }]
                    }),
                fields: ["code", "code.left", "code.right", "extCode", "extCode.left", "extCode.right", "isTourist", "isTourist.left", "isTourist.right", "orientation", "orientation.left", "orientation.right", "priority", "priority.left", "priority.right"],
                valueParser: {
                    "orientation": {
                        "C": "circular", "c": "circular",
                        "G": "ida", "g": "ida",
                        "R": "volta", "r": "volta"
                    },
                    "isTourist": {
                        "true": "turístico",
                        "false": "normal"
                    }
                }
            });
        }
        else {
            pathsFiltered = SearchHelper.search({
                filter: filter,
                data: paths,
                fields: ["code", "extCode", "isTourist", "orientation", "priority"],
                valueParser: {
                    "orientation": {
                        "C": "circular", "c": "circular",
                        "G": "ida", "g": "ida",
                        "R": "volta", "r": "volta"
                    },
                    "isTourist": {
                        "true": "turístico",
                        "false": "normal"
                    }
                }
            });
        }

        const totalPages = PaginationHelper.getTotalPages(pathsFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const pathsToRender = pathsFiltered.sort((a, b) => this.sortPaths(render.sort, a, b))
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <div className="table-loading">
                <Table responsive striped hover>
                    <thead>
                        <tr>
                            <th className="width-30p sortable" onClick={() => this.onChangeSort("code")}>Código {this.renderSortIndicator("code", render.sort)}</th>
                            <th className="width-25p sortable" onClick={() => this.onChangeSort("extCode")}>Código Externo {this.renderSortIndicator("extCode", render.sort)}</th>
                            <th className="width-10p sortable">Percurso Turístico</th>
                            <th className="width-10p sortable" onClick={() => this.onChangeSort("orientation")}>Orientação {this.renderSortIndicator("orientation", render.sort)}</th>
                            <th className="width-10p sortable" onClick={() => this.onChangeSort("priority")}>Prioridade {this.renderSortIndicator("priority", render.sort)}</th>
                            <th className="width-15p">&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody className={isLoadingPaths ? "overlay" : ""}>
                        {
                            pathsToRender.map((path, idx) =>
                                <tr key={`path-${idx}`} className={ComparisonHelper.getRowClass(path.code)}>
                                    <td>{ComparisonHelper.renderProperty(path.code)}</td>
                                    <td>{ComparisonHelper.renderProperty(path.extCode)}</td>
                                    <td>{ComparisonHelper.renderProperty(path.isTourist, this.renderIsTouristLabel)}</td>
                                    <td>{ComparisonHelper.renderProperty(path.orientation, (a) => this.renderOrientationLabel(a))}</td>
                                    <td>{ComparisonHelper.renderProperty(path.priority)}</td>
                                    <td>
                                        <ButtonToolbar className="pull-right">
                                            <TableButton marginRight icon="icon-manage-uptime" title="Periodos de Funcionamento" onClick={() => this.props.onIntervalsClick(path)} />
                                            <TableButton marginRight icon="icon-lines" title="Notas" onClick={() => this.props.onNotesClick(path)} />
                                            <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditClick(path)} />
                                            <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteClick(path)} />
                                        </ButtonToolbar>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>

                <PaginationBuilder
                    currentPage={activePage}
                    elementsPerPage={elementsPerPage}
                    dataLength={pathsFiltered.length}
                    onChangePage={this.props.onChangePage}
                    onChangeElementsPerPage={this.props.onChangeElementsPerPage} />

                {this.renderLoading(isLoadingPaths)}
            </div>
        );
    }

    render() {
        const { lines, lineSelected, isLoadingPaths } = this.props;

        return (
            <Grid fluid className="table-small-screens">
                <FormGroup controlId="formLine" className="margin-top-15">
                    <Row className="row-dropdown">
                        <Col sm={1}>
                            <ControlLabel className="control-label-dropdown">Linha</ControlLabel>
                        </Col>
                        <Col sm={11}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Selecione uma linha"
                                isDisabled={isLoadingPaths}
                                noOptionsMessage={() => "Sem Linhas Configuradas"}
                                onChange={(e) => this.props.onChangeLine(e)}
                                options={lines.sort((a, b) => (a.code > b.code) ? 1 : -1)}  // ascending order
                                isMulti={false}
                                isClearable={true}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.code}
                                value={lineSelected}
                            />
                        </Col>
                    </Row>
                </FormGroup>

                {this.renderTable(lineSelected)}
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/paths/PathsActive.js